import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function News() {
  const articles = [
    {
      slug: "cleveland-street-preachers-top-20-popular-videos",
      title: "Cleveland Street Preachers' Top 20 Popular Videos",
      date: "September 16, 2022",
      author: "Evangelize the World",
      excerpt: "As of today, September 16th, 2022, below are the top 20 most-popular YouTube videos from Cleveland Street Preachers, starting with the most-viewed. Millions of souls evangelized worldwide, and we're grateful for you to be part of our journey as we pass through this world to fulfill our God-given assignments.",
      readTime: "1 min read",
      image: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80"
    },
    {
      slug: "what-to-do-when-you-wake-up",
      title: "What's The First Thing You Should Do When You Wake Up?",
      date: "November 27, 2021",
      author: "Evangelize the World",
      excerpt: "When You Wake Up, Do This Immediately. Who do you love the most? Who is the One person you adore the most? Jesus started His day by waking up and praying, Mark 1:35. When you wake up, don't look at your phone. First thing you should do is put God literally first in your day.",
      readTime: "2 min read",
      image: "https://images.unsplash.com/photo-1506252374453-ef5237291d83?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80"
    }
  ];

  return (
    <div id="news" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Latest News</h2>
          <div className="w-24 h-1 bg-primary-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Stay updated with our latest news, events, and ministry updates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {articles.map((article, index) => (
            <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <img src={article.image} alt={article.title} className="w-full h-48 object-cover" />
              <div className="p-6">
                <div className="flex items-center text-gray-600 text-sm mb-4">
                  <Calendar size={16} className="mr-2" />
                  <span>{article.date}</span>
                  <span className="mx-2">•</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{article.title}</h3>
                <p className="text-gray-600 mb-4 line-clamp-3">{article.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">By {article.author}</span>
                  <Link 
                    to={`/article/${article.slug}`}
                    className="flex items-center text-primary-600 font-semibold hover:text-primary-700 transition-colors"
                  >
                    Read More <ArrowRight size={18} className="ml-2" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/news"
            className="inline-flex items-center bg-primary-600 text-white px-8 py-4 rounded-full hover:bg-primary-700 transition-colors"
          >
            View All News
            <ArrowRight className="ml-2" size={20} />
          </Link>
        </div>
      </div>
    </div>
  );
}